<widget-header
  [name]="widgetName"
  [editable]="isEditable"
  >

  <widget-menu slot="menu"
    [resource]="resource" />

</widget-header>
<div class="op-widget-box--body">
  @if (noEntries) {
    <op-no-results [title]="text.noResults"
     />
  }
  <ul class="widget-box--arrow-links">
    @for (news of entries; track news) {
      <li
        class="widget-box--arrow-multiline"
        >
        @if (news.author) {
          <op-principal [principal]="news.author"
            [hideName]="true"
            class="widget-box--avatar news-author-avatar hidden-for-mobile"
           />
        }
        <div class="widget-box--project">
          <a
            [href]="newsProjectPath(news)"
            [textContent]="newsProjectName(news)"
          ></a>:
          <a
            [href]="newsPath(news)"
            [textContent]="news.title"
          ></a>
        </div>
        @if (news.author) {
          <div
            class="widget-box--author news-author"
            [innerHTML]="text.addedBy(news)"
          ></div>
        }
        @if (news.summary) {
          <p
            [textContent]="news.summary"
            class="widget-box--additional-info"
          ></p>
        }
      </li>
    }
  </ul>
</div>
